/*global $*/
/*eslint no-undef: "error"*/
export default class ButtonMenu {
    classItem = 'button-menu--item'
    classButton = 'button-menu--button'

    classItemOpen = 'menu-mobile__item-open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classItem}`).toggleClass(self.classItemOpen)
        })
    }
}
